"use strict";

import angular from "angular";

require("./accounts-plan/accounts-plan.module");
require("./budget/budget.module");
require("./customization/customization.module");
require("./dashboards/dashboards.module");
require("./data-management/data-management.module");
require("./data-source/data-source.module");
require("./projection/projection.module");
require("./demonstrations/demonstrations.module");
require("./department/department.module");
require("./document-view/document-view.module");
require("./monitoring/monitoring.module");
require("./monitoring-config/monitoring-config.module");
require("./parameterization-on-demand/parameterization-on-demand.module");
require("./reports/reports.module");
require("./showtime/showtime.module");

angular.module("nucont.accounting.company", [
    "nucont.shared",
    "nucont.accounting.company.accountsPlan",
    "nucont.accounting.company.budget",
    "nucont.accounting.company.customization",
    "nucont.accounting.company.dashboards",
    "nucont.accounting.company.dataManagement",
    "nucont.accounting.company.dataSource",
    "nucont.accounting.company.demonstrations",
    "nucont.accounting.company.department",
    "nucont.accounting.company.documentView",
    "nucont.accounting.company.monitoring",
    "nucont.accounting.company.monitoringConfig",
    "nucont.accounting.company.parameterizationOnDemand",
    "nucont.accounting.company.projection",
    "nucont.accounting.company.reports",
    "nucont.accounting.company.showtime"
]);
require("./company.routes");
